import { render, staticRenderFns } from "./ArtworkItem.vue?vue&type=template&id=d78fb988&scoped=true&"
import script from "./ArtworkItem.vue?vue&type=script&lang=js&"
export * from "./ArtworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkItem.vue?vue&type=style&index=0&id=d78fb988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78fb988",
  null
  
)

export default component.exports